import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import GameGuessPlayers from "../components/Game/GameGuessPlayer";
import GameMainBox from "../components/Game/GameMainBox";
import useGame from "../context/game";
import { LEAGUES } from "../utils/constants";
import "./Game.css";
import Ad from "./Ad";
import DevelopMoodModal from "../components/DevelopMoodModal/DevelopMoodModal";

const Game = () => {
  const {
    league,
    newGameState,
    setShowHelpbox,
    oldGameState,
    gameOver,
    developMode,
  } = useGame();
  const params = useParams();

  const location = useLocation();
  console.log(developMode);
  const [inHomePageGame, setIsHomePageGame] = useState(true);

  useEffect(() => {
    if (
      !params.leagueName &&
      location.pathname !== "/guesswhofootball" &&
      location.pathname !== "/guesswhofootball/"
    )
      return;

    const _gameNo = new URLSearchParams(location?.search).get("game");
    if (_gameNo && !isNaN(_gameNo) && _gameNo > 0) {
      if (
        location.pathname === "/guesswhofootball" ||
        location.pathname === "/guesswhofootball/"
      ) {
        setIsHomePageGame(true);
        oldGameState(LEAGUES["super-league"], _gameNo);
        return;
      }
      setIsHomePageGame(false);
      oldGameState(LEAGUES[params.leagueName], _gameNo);
    } else {
      if (
        location.pathname === "/guesswhofootball" ||
        location.pathname === "/guesswhofootball/"
      ) {
        setIsHomePageGame(true);
        newGameState(LEAGUES["super-league"]);
        return;
      }
      setIsHomePageGame(false);
      newGameState(LEAGUES[params.leagueName]);
    }
  }, [params, location]);

  useEffect(() => {
    if (league) {
      let _noHelp = localStorage.getItem(`${league.id}-help`);
      if (!_noHelp) {
        localStorage.setItem(`${league.id}-help`, true);
        setShowHelpbox(true);
      }
    }
  }, [league]);

  if (!league) {
    return <div></div>;
  }

  return (
    <main className="relative game_section">
      <div className="container">
        <DevelopMoodModal open={developMode} />
        <GameMainBox />

        <GameGuessPlayers inHomePageGame={inHomePageGame} />
      </div>
    </main>
  );
};

export default Game;
